import { useTranslation } from 'react-i18next'
import { AddCar } from '~/features/common/Сars/AddCar'
import { Breadcrumbs, BreadcrumbsList } from '~/shared/ui/Breadcrumbs'
import { Container, PageContainer, PageTitle } from '~/shared/ui/Layout'

const breadcrumbs: BreadcrumbsList = [
  { titleI18n: 'cars', link: '/cars' },
  { titleI18n: 'create car' },
]

function AddCarPage() {
  const { t } = useTranslation()
  return (
    <PageContainer title={t('create car')}>
      <Container isHeader>
        <Breadcrumbs list={breadcrumbs} />
        <PageTitle>{t('create car')}</PageTitle>
      </Container>

      <AddCar />
    </PageContainer>
  )
}

export default AddCarPage
